import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

interface WeekdaySelectorProps {
  selectedDays: number[];
  onChange: (days: number[]) => void;
  currentDay?: number; // Day of week to highlight as default (0=Sunday)
}

const WeekdaySelector: React.FC<WeekdaySelectorProps> = ({
  selectedDays,
  onChange,
  currentDay,
}) => {
  const weekdays = [
    { label: 'U', value: 0, name: 'Sunday' },
    { label: 'M', value: 1, name: 'Monday' },
    { label: 'T', value: 2, name: 'Tuesday' },
    { label: 'W', value: 3, name: 'Wednesday' },
    { label: 'R', value: 4, name: 'Thursday' },
    { label: 'F', value: 5, name: 'Friday' },
    { label: 'S', value: 6, name: 'Saturday' },
  ];

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newDays: number[],
  ) => {
    // At least one day must always be selected
    if (newDays.length > 0) {
      onChange(newDays);
    }
  };

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>
        Select days (at least one required)
      </Typography>
      <ToggleButtonGroup
        value={selectedDays}
        onChange={handleChange}
        aria-label="weekday selection"
        size="small"
        sx={{
          display: 'flex',
          gap: 0.5,
        }}
      >
        {weekdays.map((day) => (
          <ToggleButton
            key={day.value}
            value={day.value}
            aria-label={day.name}
            sx={{
              px: 1.5,
              py: 0.5,
              fontSize: '0.875rem',
              fontWeight: selectedDays.includes(day.value) ? 'bold' : 'normal',
              minWidth: '32px',
              '&.Mui-selected': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              },
            }}
          >
            {day.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default WeekdaySelector;
